import VueNotifications from 'vue-notifications';

export const notificationMixin = {
    methods: {
        $_notificationMixin_success(title, message) {
            VueNotifications.success({
                title: title,
                message: message,
                timeout: 5000
            });
        },
        $_notificationMixin_error(title, message) {
            VueNotifications.error({
                title: title,
                message: message,
                timeout: 5000
            });
        },
        $_notificationMixin_warn(title, message) {
            VueNotifications.warn({
                title: title,
                message: message,
                timeout: 5000
            });
        }
    }
};